export default __webpack_public_path__ + "static/media/friend-inactive-color-icon.04fc5187.svg";